export function getWorkflowDocumentFile(record, field) {
    const value = record?.values?.[field]
    const file = Array.isArray(value) ? value[0] : value

    if (typeof file === 'string' && file.trim()) {
        return { address: file.trim() }
    }

    return file && typeof file === 'object' ? file : null
}

export function isTableActionVisible(action, record, userType) {
    if (Array.isArray(action?.visibleForUserTypes)
        && !action.visibleForUserTypes.includes(userType)) return false
    if (!action?.documentField) return true
    return Boolean(getWorkflowDocumentFile(record, action.documentField)?.address)
}
